import { type EventContentArg } from "@fullcalendar/core"
import React from "react"

import { CalendarEventCellBreak } from "./CalendarEventCellBreak.tsx"
import { CalendarEventCellEvent } from "./CalendarEventCellEvent.tsx"
import { CalendarEventCellReminder } from "./CalendarEventCellReminder.tsx"

export function CalendarEventCell(eventInfo: EventContentArg) {
  const isBreak = eventInfo?.event?.extendedProps?.isBreak === true
  const isReminder = eventInfo?.event?.extendedProps?.type === "reminder"

  if (isBreak) return <CalendarEventCellBreak eventInfo={eventInfo} />

  return (
    <div className={`size-full overflow-hidden`}>
      {isReminder ? (
        <CalendarEventCellReminder eventInfo={eventInfo} />
      ) : (
        <CalendarEventCellEvent eventInfo={eventInfo} />
      )}
    </div>
  )
}
